import * as actionTypes from '../actions'

interface IdisplayRoute {
    route: string,
    routeName: string,
    display: "desktop" | "mobile" | "",
}

const initialState: IdisplayRoute = {
    route: "/",
    routeName: "home",
    display: "",
}

const displayRouteReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.SET_ROUTE: {
      return {
        ...state,
        route: action.payload.route,
        routeName: action.payload.routeName
      }
    }
    case actionTypes.SET_DISPLAY: {
      return {
        ...state,
        display: action.payload.display
      }
    }

    default: {
      return state
    }
  }
}

export default displayRouteReducer